import type { FC } from 'react';
import { SchemaIcon } from './schema-display';
import { BuilderTooltip } from './BuilderTooltip';
import type { FieldConditionSubject } from './segment-builder.types';
import styles from './SegmentVisualBuilder.module.css';

/** The schema name is the trigger's accessible name as well as its tooltip — it replaces a written "The Customer's" lead-in. */
export const SchemaAttributeBadge: FC<{ subject: FieldConditionSubject }> = ({ subject }) => {
  const label = `This is a ${subject.name} attribute`;

  return (
    <BuilderTooltip label={label}>
      <button type="button" className={styles.schemaAttributeBadge} aria-label={label}>
        <SchemaIcon displayMetadata={subject.displayMetadata} size={16} />
      </button>
    </BuilderTooltip>
  );
};
